import { render, staticRenderFns } from "./HSBC.vue?vue&type=template&id=57881e1d&"
import script from "./HSBC.vue?vue&type=script&lang=js&"
export * from "./HSBC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QToolbar,QToolbarTitle,QBtn,QTable,QTd,QSelect,QBadge} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QToolbar,QToolbarTitle,QBtn,QTable,QTd,QSelect,QBadge})
